// extracted by mini-css-extract-plugin
export var actionButton = "_8z-0";
export var attachmentLine = "_8z-1";
export var fileInput = "_8z-2";
export var fileUploadWrapper = "_8z-4";
export var footer = "_8z-3";
export var modalContent = "_8z-5";
export var paperclip = "_8z-6";
export var quillEditor = "_8z-7";